import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Newport",
  metaDescription: "Local plumber in Newport, MN. Bruce Nelson Plumbing & Heating provides fast, reliable plumbing and heating services. Call 651-738-9354 today.",
  heroTitle: "Plumber in Newport, MN",
  heroSubtitle: "Reliable plumbing services for Newport homes and businesses.",
  introduction: "Newport residents count on Bruce Nelson Plumbing & Heating for quality plumbing services. Our team serves the entire Newport community, from the historic downtown area to the neighborhoods along the Mississippi. With nearly 50 years of experience, we understand the plumbing needs of Newport's diverse housing stock.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Complete home plumbing services for Newport residents.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing solutions for Newport businesses.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler repair and installation in Newport.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Quick water heater service for Newport homeowners.",
      link: "/services/water-heaters"
    },
    {
      title: "Drain Cleaning",
      description: "Professional drain cleaning throughout Newport.",
      link: "/services"
    },
    {
      title: "Bathroom Remodeling",
      description: "Update your Newport bathroom with our remodeling services.",
      link: "/services/remodeling"
    }
  ],
  whyChooseUs: [
    "Serving Newport and the east metro since 1976",
    "Fully licensed, bonded, and insured",
    "Experience with older Newport homes",
    "Transparent, upfront pricing",
    "Quick response times to Newport",
    "Excellent customer reviews"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Cottage Grove", link: "/plumber-cottage-grove" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Rosemount", link: "/plumber-rosemount" }
  ],
  testimonial: {
    text: "Fast, professional service! BNPH fixed our plumbing problem the same day we called. Highly recommend them to Newport neighbors!",
    author: "Nancy T."
  }
};

const NewportPage = () => <CityPageTemplate cityData={cityData} />;

export default NewportPage;
